<template>
  <div class="shop-sets">
    <div class="shop-sets__header">
      <h2 class="m-0">{{ $tc('shopSet', 2) }}</h2>
      <ButtonComponent
        :label="$t('manualSelectAndSkip')"
        :icon="['fal', 'angle-right']"
        @click="$emit('select')"
      />
    </div>
    <Card
      v-for="set in value.sets"
      :key="set.id"
      :value="set"
      :shop="value"
      @select="$ev => $emit('select', $ev)"
    />
  </div>
</template>

<script>
import Card from './Card'

export default {
  props: {
    value: Object,
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
@import '../mixins.scss';

.shop-sets {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  grid-auto-rows: min-content;
  gap: 2rem;

  @include onPhone {
    grid-template-columns: 1fr;

    .shop-set-card {
      --kvass-card-spacing: 1rem;
    }
  }

  &__header {
    gap: 1rem;

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    grid-column: 1 / -1;
  }

  .kvass-card__header {
    aspect-ratio: 2 / 1;
  }
}
</style>
